import { UserPaymentDetailsStatus } from '../../../../../../../enums';

/**
 * getCardIcon function
 * This function is responsible for returning the appropriate icon class based on the user payment details status.
 *
 * @param {UserPaymentDetailsStatus} status - The status of the user payment details.
 * @returns {string} The icon class corresponding to the given status.
 *
 * @example
 * // Usage example:
 * const iconClass = getCardIcon(UserPaymentDetailsStatus.Created);
 */
export function getCardIcon(status: UserPaymentDetailsStatus): string {
  switch (status) {
    case UserPaymentDetailsStatus.Created:
      return 'fa-solid fa-clock';
    case UserPaymentDetailsStatus.Verified:
      return 'fa-solid fa-badge-check';
    case UserPaymentDetailsStatus.Rejected:
      return 'fa-solid fa-circle-exclamation';
  }
}
